enum Codenames {
  KiteDefaultCurrency = "ff8ef60d-7a8c-4552-8c00-630468b6f058",
  GenerateInward = "Generate Inward",
}

export default Codenames
